import { Currency } from '@/core/currency/interfaces';

const SZL: Currency = {
    name: 'Swazi Lilangeni',
    demonym: 'Swazi',
    majorSingle: 'Lilangeni',
    majorPlural: 'Emalangeni',
    codeNumeric: '748',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SZL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SZL;
